import RestService from '@/modules/backend/RestService';
import { Role } from '@/modules/backend/Entities/Role';
import { plainToClass } from 'class-transformer';
import { CreateRoleData } from '@/modules/backend/Dto/CreateRoleData';

export default class Roles {
  private readonly rest: RestService;

  public constructor(rest: RestService) {
    this.rest = rest;
  }

  public async Create(payload: CreateRoleData): Promise<Role> {
    const item = await this.rest.post('/api/v3/role', payload);
    return plainToClass(Role, item);
  }

  public async Remove(roleId: number): Promise<void> {
    await this.rest.delete(`/api/v3/role/${roleId}`);
  }

  public async List(): Promise<Role[]> {
    const items = await this.rest.get<unknown[]>('/api/v3/roles');
    return plainToClass(Role, items);
  }
}
